module.exports = __webpack_public_path__ + "media/100.7a042439.wav";